import React, { useState } from "react";
import FormColorTC from "../../../../components/Forms/FormColorTC";
import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  GridLegacy,
  MenuItem,
} from "@mui/material";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import CustomFonts from "./Fonts/CustomFonts";
import FormFile from "../../../../components/Forms/FormFile";
import CustomComponents from "./CustomComponents";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import CardBody from "../../../../components/Card/CardBody";
import Button from "../../../../../components/Buttons/Button";
import { useDialog } from "../../../../licensing/utils/DialogProvider";
import { useWatch } from "react-hook-form";
import AsynchronousAutocomplete from "../../../../components/Autocomplete/AsynchronousAutocomplete";
import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import axios from "axios";

function ImportStylesDialog({ vestigingId }) {
  const [importSalesareaId, setImportSalesareaId] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <Box>
      <DialogTitle>
        <TranslationWrapper tDefault={"Import styles"} tKey={"import-styles.heading"} />
      </DialogTitle>
      <DialogContent>
        <p>
          <TranslationWrapper
            tDefault="Import all styles from another salesarea. This includes the theme mode, the color palette, fonts and css set
          with the live interface or customComponents."
            tKey={"import-styles.description"}
          />
        </p>
        <AsynchronousAutocomplete
          async={{
            url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=10",
            searchField: "systeemNaam",
          }}
          onChange={(e, option) => {
            setImportSalesareaId(option.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton
          disabled={importSalesareaId === null}
          loading={loading}
          onClick={() => {
            setLoading(true);
            axios
              .post("core/importStyles", {
                targetSalesareaId: vestigingId,
                importSalesareaId,
              })
              .then(() => {
                location.reload();
              })
              .finally(() => {
                setLoading(false);
              });
          }}
        >
          <TranslationWrapper tDefault={"Import styles"} tKey={"import-styles.btn.text"} />
        </LoadingButton>
      </DialogActions>
    </Box>
  );
}

export default function BrandingV5(props) {
  const [openDialog] = useDialog();
  const vestigingId = useWatch({ name: "id" });

  return (
    <GridLegacy container spacing={1}>
      <GridLegacy item style={{ marginBottom: 10 }} xs={12}>
        <Card>
          <CardBody>
            {/*<LiveKiosk />*/}
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Theme settings"}
                  tKey={"vestigingen.form.branding.headers.themesettings"}
                />
                <Button
                  color={"info"}
                  onClick={() => {
                    openDialog({
                      children: <ImportStylesDialog vestigingId={vestigingId} />,
                    });
                  }}
                  size={"small"}
                  sx={{ marginLeft: 1 }}
                >
                  <TranslationWrapper tDefault={"Import styles"} tKey={"vestigingen.form.branding.import-styles"} />
                </Button>
              </h3>
            </GridLegacy>
            <FormSelectTC
              name={"extra_settings__mui_theme_mode"}
              options={[
                <MenuItem key={1} value={"light"}>
                  Light
                </MenuItem>,
                <MenuItem key={2} value={"dark"}>
                  Dark
                </MenuItem>,
              ]}
              tDefault={"Theme mode"}
              tKey={"extra_settings__mui_theme_mode"}
            />
            <FormColorTC
              name={"extra_settings__mui_theme_palette_primary_main"}
              rules={{
                required: { value: true, message: getTranslation("This field is required!") },
              }}
              tDefault={"Primary color"}
              tKey={"extra_settings__mui_theme_palette_primary_main"}
            />
            <FormColorTC
              name={"extra_settings__mui_theme_palette_primary_light"}
              nullable
              tDefault={"Light color"}
              tKey={"extra_settings__mui_theme_palette_primary_light"}
            />
            <FormColorTC
              name={"custom_data.styling.mui_theme_background_default"}
              nullable
              tDefault={"Default Background Color"}
              tKey={"custom_data.styling.mui_theme_background_default"}
            />
            <FormColorTC
              name={"custom_data.styling.mui_theme_background_paper"}
              nullable
              tDefault={"Paper Background Color"}
              tKey={"custom_data.styling.mui_theme_background_paper"}
            />
            <FormControlledInputTC
              name={"extra_settings__mui_theme_typography_font_size_qr"}
              rules={{
                min: { value: 1, message: getTranslation("The minimum value is 1!") },
                required: { value: true, message: getTranslation("This field is required!") },
              }}
              tDefault={"Typography font size QR"}
              tKey={"extra_settings__mui_theme_typography_font_size_qr"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"extra_settings__mui_theme_typography_font_size_kiosk"}
              rules={{
                min: { value: 1, message: getTranslation("The minimum value is 1!") },
                required: { value: true, message: getTranslation("This field is required!") },
              }}
              tDefault={"Typography font size Kiosk"}
              tKey={"extra_settings__mui_theme_typography_font_size_kiosk"}
              type={"number"}
            />
            <FormTextTC
              name={"extra_settings__mui_theme_typography_font_family"}
              tDefault={"Typography font family"}
              tKey={"extra_settings__mui_theme_typography_font_family"}
            />

            <GridLegacy item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Upload image for missing images at articles"}
                  tKey={"extra_settings__article_missing_image_placeholder"}
                />
              </FormLabel>
            </GridLegacy>
            <GridLegacy item sm={8} xs={12}>
              <FormFile
                canCrop={true}
                name={"extra_settings__article_missing_image_placeholder"}
                nullable={true}
                type={"image"}
              />
            </GridLegacy>
            <FormSwitchTC
              name={"custom_data.appv5_use_articlegroups_hierarchically.enabled"}
              tDefault={"Use articlegroups hierarchically"}
              tKey={"custom_data.appv5_use_articlegroups_hierarchically.enabled"}
            />

            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.appv5_always_show_options_using_quick_add_order_button.enabled"}
              tDefault={"Always show product options when using quick add order button"}
              tKey={"custom_data.appv5_always_show_options_using_quick_add_order_button.enabled"}
            />

            <FormSwitchTC
              defaultValue={true}
              name={"custom_data.styling.kiosk.showName"}
              tDefault={"Kiosk show name"}
              tKey={"custom_data.styling.kiosk.showName"}
            />

            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.styling.kiosk.stickyBanner"}
              tDefault={"Kiosk have a sticky banner"}
              tKey={"custom_data.styling.kiosk.stickyBanner"}
            />
          </CardBody>
        </Card>
      </GridLegacy>

      <GridLegacy item style={{ marginBottom: 12 }} xs={12}>
        <Card>
          <CardBody>
            <CustomFonts errors={props.errors} />
          </CardBody>
        </Card>
      </GridLegacy>

      <GridLegacy item style={{ marginBottom: 16 }} xs={12}>
        <Card>
          <CardBody>
            <CustomComponents />
          </CardBody>
        </Card>
      </GridLegacy>
    </GridLegacy>
  );
}

function LiveKiosk() {
  return <iframe height={1920} src={"/v5/kiosk"} width={1080} />;
}
